/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : UnauthorizedError.ts
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       :  Madhu Gali - H175591
 *
 * @Date         : Jan 10, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali - H175591
 * On            : Jan 10, 2019
 * Description   : ASDS-2152
 ******************************************************************************/

class UnauthorizedError extends Error {
    constructor(message) {
        super(message);
    }
}

export default UnauthorizedError;